import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./store";
import registerServiceWorker from "./registerServiceWorker";
import Index from "./pages/index";
import "./index.css";
// import uuidv4 from "uuid/v4";

// const nonce = new Buffer(uuidv4()).toString("base64");

const rootElement = document.querySelector("#root");
if (rootElement) {
  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Index />
      </ConnectedRouter>
    </Provider>,
    rootElement
  );
}
registerServiceWorker();
